<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-card flat class="mb-4">
          <v-card-title class="subheading font-weight-bold justify-left">
            Thông tin doanh nghiệp
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="7">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Trạng thái</v-list-item-content>
                    <v-list-item-content class="align-end">
                      <span v-if="item.trangThai == 0">Dừng hoạt động</span>
                      <span v-else-if="item.trangThai == 2">Tạm ngưng hoạt động</span>
                      <span v-else>Đang hoạt động</span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Chủ cơ sở:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.tenChuCoSo}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Loại hình SXKD:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.loaiHinhSXKD}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.loaiCoSoCungCapGiong">
                    <v-list-item-content class="font-weight-bold">Loại doanh nghiệp:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.loaiCoSoCungCapGiong.dienGiai}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.nltsChuLuc">
                    <v-list-item-content class="font-weight-bold">Ngành hàng:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.nltsChuLuc.nganhHang}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Số giấy phép:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.gpkd}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <v-img
                  v-if="item.logo"
                  :src="item.logo"
                  contain
                />
                <v-img
                  v-else
                  src="@/assets/business-logo-default.png"
                  contain
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <BusinessTinyMap :positionObj="position" :businessObj="item"/>
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold justify-left">
                Thông tin liên quan
                <v-spacer/>
                <v-btn icon @click="moreInfoShow=!moreInfoShow">
                  <v-icon>mdi-chevron{{moreInfoShow ? '-up' : '-down'}}</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text v-if="moreInfoShow">
                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr class="primary lighten-2 rounded-t-lg">
                            <th class="white--text text-left text-subtitle-1">
                              Thông số
                            </th>
                            <th class="white--text text-center text-subtitle-1">
                              Giá trị
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Sản lượng thông thường</td>
                            <td class="text-center">
                              <span v-if="item.sanLuong">{{item.sanLuong | currency('đ')}}</span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Sản lượng GTGT cao</td>
                            <td class="text-center">
                              <span v-if="item.sanLuongCao">{{item.sanLuongCao | currency('đ')}}</span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Công suất thiết kế</td>
                            <td class="text-center">
                              <span v-if="item.congSuatThietKe">{{item.congSuatThietKe | currency('đ')}}</span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Công suất kho/ kho lạnh</td>
                            <td class="text-center">
                              <span v-if="item.congSuat">{{item.congSuat | currency('đ')}}</span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                          <tr>
                            <td>Tổng số lao động</td>
                            <td class="text-center">
                              <span v-if="item.tongSoLaoDong">{{item.tongSoLaoDong | currency('đ')}}</span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat>
          <v-card-text class="text-center">
            <span class="text-h6 font-weight-bold">
              Doanh nghiệp khác
            </span>
          </v-card-text>
          <v-card-text class="text-center" v-if="relatedItems.length == 0">
            <span>
              Không tìm thấy doanh nghiệp liên quan
            </span>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-card 
                flat 
                v-for="(related_item, index) in relatedItems"
                :key="index"
                :to="{ name: 'BusinessView', params: { id: related_item.id }}"
                class="px-6"
              >
                <div class="d-flex flex-no-wrap">
                  <v-avatar
                    class="ma-3 rounded-lg"
                    size="100"
                    tile
                  >
                    <v-img
                      v-if="related_item.logo"
                      :src="related_item.logo"
                    />
                    <v-img 
                      v-else
                      src="@/assets/business-logo-default.png"
                    />
                  </v-avatar>
                  <div>
                    <v-card-title class="text-h6 pb-1">
                      {{related_item.tenCoSo}}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-2 mb-2">
                        <v-icon 
                          small 
                          :color="related_item.trangThai == 0 ? 'gray' : (related_item.trangThai == 2 ? 'yellow' : 'primary')"
                        >
                          mdi-circle
                        </v-icon>
                        <span v-if="related_item.trangThai == 0">Dừng hoạt động</span>
                        <span v-else-if="related_item.trangThai == 2">Tạm ngưng hoạt động</span>
                        <span v-else>Đang hoạt động</span>
                      </div>
                      <div class="text-body-2">
                        <v-icon small>
                          mdi-map-marker
                        </v-icon>Địa chỉ: 
                        {{related_item.dmXa.ten}}, {{related_item.dmHuyen.ten}}, {{related_item.dmTinh.ten}}
                      </div>
                    </v-card-text>
                  </div>
                </div>
              </v-card>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import BusinessTinyMap from "@/components/public/business/BusinessTinyMap";
  import { mapActions } from 'vuex';
  import SystemSevice from '@/services/System';
  export default {
    components: {
      BaseBreadcrumbs,
      BusinessTinyMap
    },
    data: () => ({
      crumbs: [],
      item: {},
      relatedItems: [],
      position: {
        lat:  10.420288, 
        lng: 106.296844
      },
      moreInfoShow: true,
    }),
    watch: {
      "$route.params.id": function() {
        this.initialize();
        this.getRelatedItems();
      }
    },
    mounted() {
      this.getRelatedItems();
      this.initialize();
      SystemSevice.setSiteViewLocal({
        name: `BusinessView@${this.$route.params.id}`,
      })
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      initialize(){
        const app = this;
        app.getLoader(true);
        axios.get(`api/v1/public/get-agridata-breed-business/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            if(app.item.toaDo){
              app.position={
                lat: parseFloat(app.item.toaDo.split(",")[0]), 
                lng: parseFloat(app.item.toaDo.split(",")[1])
              };
            } else {
              app.position={
                lat:  10.420288, 
                lng: 106.296844
              };
            }
            app.crumbs = [
              {
                text: 'Trang chủ',
                disabled: false,
                href: '/',
              },
              {
                text: 'Cơ sở sản xuất, kinh doanh',
                disabled: false,
                href: '/business',
              },
              {
                text: app.item.tenCoSo,
                disabled: true
              }
            ];
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getRelatedItems(){
        axios.get(`api/v1/public/get-agridata-rel-breed-business/${this.$route.params.id}`)
          .then(response => {
            this.relatedItems = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>